import { render, staticRenderFns } from "./central-config-tour-guiado.vue?vue&type=template&id=5e686f4c&"
import script from "./central-config-tour-guiado.vue?vue&type=script&lang=js&"
export * from "./central-config-tour-guiado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e686f4c')) {
      api.createRecord('5e686f4c', component.options)
    } else {
      api.reload('5e686f4c', component.options)
    }
    module.hot.accept("./central-config-tour-guiado.vue?vue&type=template&id=5e686f4c&", function () {
      api.rerender('5e686f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/central-config/components/central-config-tour-guiado/central-config-tour-guiado.vue"
export default component.exports